import {
  PlaceholderData,
  getSelectedNode,
  getSelectedStep,
} from "./reducer/stateUtils";
import { AddItemForm, AddItemData } from "./AddItemForm";
import { TriggerStepForm } from "./TriggerStepForm";
import { ConditionalForm } from "./ConditionalForm";
import { useTriggerEditorStateDispatch } from "./TriggerEditor";
import { TriggerRootForm } from "./TriggerRootForm";
import { v4 as uuidv4 } from "uuid";
import { isOfTypeSupportedStep } from "@dots-projects/types";

/**
 * The container of the panel for StepFormXXX and AddItemForm etc.
 *
 * Based on the type of the selected node, renders a TriggerStepForm, AddItemForm, or a ConditionalForm.
 */
export function PropsPanel() {
  const { state } = useTriggerEditorStateDispatch();
  const selectedNode = getSelectedNode(state);
  if (!selectedNode) return null;
  const step = getSelectedStep(state);
  // When unsupported warning is active and selected step is not supported we don't want to show props panel form. This is usefull when unsupported step is clicked and there are validation errors... in that case we show the old unsupported step view.
  const isWarningOpenAndStepIsUnsupported =
    state.editor.visibleErrorBoxId === "unsupported-step" &&
    step?.type &&
    !isOfTypeSupportedStep(step.type);

  let panelContent;

  if (selectedNode && !isWarningOpenAndStepIsUnsupported) {
    switch (selectedNode.type) {
      case "trigger":
        panelContent = <TriggerRootForm trigger={state.trigger.current} />;
        break;
      case "step":
        {
          // The "key" here is important! Try deleting it and select multiple `send_message` nodes.
          panelContent = step ? (
            <TriggerStepForm
              step={step}
              trigger={state.trigger.current}
              key={step.id}
            />
          ) : null;
        }
        break;
      case "placeholder":
        const addItemData = selectedNode.data as PlaceholderData;
        panelContent = <AddItemForm data={addItemData} />;
        break;
      case "condition":
        {
          panelContent = step ? (
            <ConditionalForm step={step} key={uuidv4()} />
          ) : null;
        }
        break;
    }
  }
  return panelContent ? (
    <div
      className={`absolute right-0 top-20 bottom-4 mr-4 z-50 flex flex-row place-items-center h-160 ease-in-out transform transition-all duration-500 ${
        selectedNode ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div
        className={`ml-2 border-4 overflow-auto transition-all duration-500 rounded-lg border-dots-vibrant-orange shadow-lg p-6 z-10 bg-white w-80 h-full `}
      >
        {selectedNode ? panelContent : null}
      </div>
    </div>
  ) : null;
}
